import { TInputParams } from 'entries/common/widgets/context';
import { ParametersEnum } from '../types';

type TProps = {
  inputParameters: TInputParams;
};

export const hasAreaInRoom = ({ inputParameters }: TProps) => inputParameters.includes(ParametersEnum.area);
